<template>
  <div class="suite_app_edit_wrap">
    <div class="left_box">
      <el-menu :default-active="currentSuite" class="el-menu-vertical-demo" @select="changeMenu">
        <el-menu-item :index="item.suiteId" :key="item.id" v-for="item in allSuiteList">
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right_box">
      <div class="header">
          <template v-if="isShowByPermission('/wyms/suiteRole/addSuiteRole')">
              <el-button size="medium" type="primary" @click="editSuiteModule" v-if="!canSelect">编辑</el-button>
              <el-button size="medium" type="primary" @click="saveSuiteModule" v-else>保存</el-button>
          </template>

        <el-radio-group v-model="schoolType" size="medium" style="margin-left: 10px;" @change="changeSchoolType" v-if="isShowTabBox">
          <el-radio-button label="1">幼儿园</el-radio-button>
          <el-radio-button label="2">中小学</el-radio-button>
          <el-radio-button label="5">教育局</el-radio-button>
        </el-radio-group>
      </div>
      <div class="suite_app_edit_box" :style="`height: ${windowHeight - 160}px;`">
        <div class="suite_app_edit_content">
          <el-checkbox-group v-model="moduleCheckList">
            <el-checkbox class="check_item" :label="`${item.constantId} ${item.name}`" :disabled="!canSelect" :key="item.id" v-for="item in dataList"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize'
  import {getSuiteList, showRoleList, addSuiteRole} from '@/api/suiteSystem'

  export default {
    name: "suiteRoleIndex",
    data() {
      return {
        isShowTabBox: true,
        canSelect: false,
        allSuiteList: [],
        currentSuite: null,
        schoolType: 1,
        moduleCheckList: [],
        dataList: []
      }
    },
    mixins: [windowResize],
    watch: {
      currentSuite() {
        this.canSelect = false;
        this.schoolType = 1;
        this.showRoleList();
      }
    },
    created() {
      this.getSuiteList();
    },
    methods: {
        isShowByPermission,
      goBack() {
        this.$router.go(-1);
      },
      changeMenu(val) {
        const suiteIdList = this.allSuiteList.map(item => item.suiteId);
        const suiteIdIndex = suiteIdList.indexOf(val);
        this.isShowTabBox = this.allSuiteList[suiteIdIndex].suiteEnvironment !== 3;
        this.currentSuite = val;
      },
      changeSchoolType() {
        this.canSelect = false;
        this.showRoleList();
      },
      getSuiteList() {
        getSuiteList({isExcludedTxl: true}).then(data => {
          this.allSuiteList = data;
          this.currentSuite = data[0].suiteId;
        })
      },
      showRoleList() {
        showRoleList({suiteId: this.currentSuite, schoolType: this.schoolType}).then(data => {
          this.dataList = data;
          this.moduleCheckList = [];
          data.forEach((item) => {
            if (item.isChoice === 1) {
              this.moduleCheckList.push(item.constantId + ' ' +item.name);
            }
          });
        })
      },
      editSuiteModule() {
        this.canSelect = true;
      },
      saveSuiteModule() {
        if (this.moduleCheckList.length) {
          let emptyArray = [];
          this.moduleCheckList.forEach((item) => {
            emptyArray.push(item.split(' ')[0])
          });
          this.addSuiteRole(emptyArray);
        } else {
          this.$message.warning('请选择模块');
        }
      },
      addSuiteRole(moduleList) {
        addSuiteRole({
          roleList: moduleList.toString(),
          schoolType: this.schoolType,
          suiteId: this.currentSuite
        }).then(data => {
          this.$message.success('保存成功');
          this.canSelect = false;
        })
      }
    }
  }
</script>

<style>
  .suite_app_edit_wrap .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #409EFF !important;
  }
  .suite_app_edit_wrap .el-menu-item{
    height: 36px;
    line-height: 36px;
  }
</style>
<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .suite_app_edit_wrap{
    height: 100%;
    padding: 12px;
    display: flex;
    box-sizing: border-box;

    .left_box{
      width: 180px;
      height: 100%;
      border-right: 1px solid #eee;
      @include scrollBar;
    }
    .right_box{
      flex: 1;
      .header {
        padding-bottom: 10px;
        padding-left: 10px;
        border-bottom: 1px solid #eee;
      }

      .suite_app_edit_box{
        @include scrollBar;
        overflow: auto;
        .suite_app_edit_content{
          margin: 10px auto;
          .check_item{
            width: 179px;
            margin: 10px;
            overflow: hidden;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/suiteSystem/suiteRole/suiteRoleIndex.vue